import { render } from "./LoaderVisulizer.vue?vue&type=template&id=637fdca6"
import script from "./LoaderVisulizer.vue?vue&type=script&lang=js"
export * from "./LoaderVisulizer.vue?vue&type=script&lang=js"

import "@/assets/scss/loader.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__